import React from 'react';
import styles from './NavigationCard.module.scss';
import { ArrowRight, Target } from 'react-feather';

export default function NavigationCard({ headline, subheadline, image, featured = false }) {
    return (
        <div className={featured ? styles.featured : styles.card}>
            <h1 className={styles.linkHeadline}>{headline}</h1>
            <p className={styles.linkSubheadline}>{subheadline}</p>
            <div className={styles.linkImgWrapper}>
                <img src={image} />
            </div>
            <div className={styles.linkArrow}>
                {featured && <span className={styles.mobileAction}>Log a book</span>}
                <ArrowRight />
            </div>
        </div>
    )
}

